<div class="flex items-center justify-between bg-gray-100 px-6 py-4">
  <h2 class="m-0 text-lg font-medium">Device Logs</h2>
  <button
    mat-flat-button
    color="primary"
    [disabled]="requesting()"
    (click)="requestLogs()"
  >
    @if (requesting()) {
      <mat-spinner diameter="18" class="mr-2" />
    }
    <span>Request Updated Logs</span>
  </button>
</div>

<mat-dialog-content>
  @if (successMessage(); as message) {
    <div class="mb-4 rounded bg-green-50 px-4 py-2 text-sm text-green-700">
      {{ message }}
    </div>
  }
  @if (errorMessage(); as message) {
    <div class="mb-4 rounded bg-red-50 px-4 py-2 text-sm text-red-700">
      {{ message }}
    </div>
  }
  <pt-attachments [editable]="false" [attachments]="logs$ | async" />
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button mat-dialog-close>Close</button>
</mat-dialog-actions>
